import { createContext } from 'react';

export const PotreeSourcesContext = createContext<{ isLoaded?: boolean }>({ isLoaded: false });
